module.exports = __webpack_public_path__ + "static/media/sabanci-logo.284678a0.jpg";